<template>
  <default-layout>
    <div>
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="limit"
        :server-items-length="serverItemsLength"
        :options.sync="paginationOptions"
        item-key="id"
        :loading="loading"
        class="elevation-2"
        :multi-sort="false"
        :must-sort="true"
        sort-by="name"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100]
        }"
        @update:options="updatePaginationOptions($event)"
      >
        <template v-slot:item.companyId="{ item }">
          <span v-if="item.companyId">
            <router-link
              :to="{
                name: 'CompanyShow',
                params: { companyId: item.companyId }
              }"
              >{{ `${item.companyId} – ${item.companyName}` }}</router-link
            >
          </span>
          <span v-else></span>
        </template>

        <template v-slot:item.lastLoginAt="{ item }">
          {{ item.lastLoginAt | dateTime }}
        </template>

        <template v-slot:item.createdAt="{ item }">
          {{ item.createdAt | dateTime }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                color="primary"
                v-on="on"
                :to="{ name: 'UserShow', params: { userId: item.id } }"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>View User</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                color="primary"
                v-on="on"
                :to="{ name: 'UserEdit', params: { userId: item.id } }"
              >
                <v-icon>mdi-account-edit</v-icon>
              </v-btn>
            </template>
            <span>Edit User</span>
          </v-tooltip>

          <v-dialog
            v-if="item.connectStatus === 'Pending'"
            v-model="dialog[item.id]"
            width="500"
          >
            <template v-slot:activator="{ on: dialog, attrs }">
              <v-tooltip top>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...dialog }"
                  >
                    <v-icon>mdi-account-check</v-icon>
                  </v-btn>
                </template>
                <span>Authorize user</span>
              </v-tooltip>
            </template>

            <v-card>
              <v-card-title> Authorize User? </v-card-title>

              <v-card-text>
                This action will authorize the user and set all associated
                facilities as claimed.
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="dialog[item.id] = false">
                  No
                </v-btn>
                <v-btn color="primary" text @click="approveUser(item.id)">
                  Yes
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:top>
          <v-row>
            <!-- FACILITY SEARCH -->
            <v-col class="pl-7">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                @keyup.enter="searchUsers()"
              ></v-text-field>
            </v-col>

            <!-- SEARCH BUTTON-->
            <v-col>
              <v-btn class="primary mt-3" @click="searchUsers()">Search </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </div>
  </default-layout>
</template>

<script>
import { listUsers, approveUser } from "../../api/user";

export default {
  name: "UserList",
  title: "Users",

  data() {
    return {
      users: [],
      limit: 20,
      offset: 0,
      search: "",
      serverItemsLength: 0,
      loading: false,
      dialog: {},
      headers: [
        { text: "ID", value: "id", sortable: false },
        { text: "RPP ID", value: "connectId", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "First Name", value: "firstName", sortable: false },
        { text: "Last Name", value: "lastName", sortable: false },
        { text: "Role", value: "role", sortable: false },
        { text: "Status", value: "connectStatus", sortable: false },
        { text: "Provider", value: "companyId", sortable: false },
        {
          text: "Last Login",
          value: "lastLoginAt",
          sortable: false,
          width: "170px"
        },
        { text: "Created", value: "createdAt", sortable: false },
        { text: "", value: "actions", sortable: false }
      ],
      paginationOptions: {
        itemsPerPage: 20,
        page: 1
      }
    };
  },

  mounted() {
    this.searchUsers();
  },

  methods: {
    async searchUsers() {
      this.offset = 0;
      this.paginationOptions.page = 1;

      await this.getUsers();
      this.awaitingSearch = false;
    },
    async getUsers() {
      try {
        this.loading = true;
        const result = await listUsers(this.page, this.limit, this.search);
        this.users = result.items.map(user => {
          user.connectStatus = user.connectStatus ? "Approved" : "Pending";
          return user;
        });

        this.serverItemsLength = result.total;
        this.companies = result.items;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    },
    async approveUser(userId) {
      await approveUser(userId);

      const user = this.users.find(user => user.id === userId);
      user.connectStatus = "Approved";
      this.dialog[userId] = false;
    },
    updatePaginationOptions(paginationOptions) {
      this.page = paginationOptions.page - 1;
      this.limit = paginationOptions.itemsPerPage;

      this.getUsers();
    }
  }
};
</script>

<style scoped></style>
